import header from '../components/header/Header.i18n.he';
import quickAbout from '../components/sections/quickAbout/QuickAbout.i18n.he';
import footer from '../components/footer/Footer.i18n.he';
import contactMeForm from '../components/contactMeForm/ContactMeForm.i18n.he';
import contacts from '../screens/contacts/Contacts.i18n.he';
import contact from '../components/sections/contact/Contact.i18n.he';
import myJourney from '../components/sections/myJourney/MyJourney.i18n.he';
import stack from '../components/sections/stack/Stack.i18n.he';
import notFound from '../screens/notFound/NotFound.i18n.he';
import projectCard from '../components/projectCard/ProjectCard.i18n.he';
import projects from '../screens/projects/Projects.i18n.he';
import about from '../screens/about/About.i18n.he';

export const heDictionary = {
    header,
    quickAbout,
    footer,
    contactMeForm,
    contacts,
    contact,
    myJourney,
    stack,
    notFound,
    projectCard,
    projects,
    about,
};
